module.exports = __webpack_public_path__ + "img/chart.1bcdf1a.png";